<div>
  {{ supplierFacetCount }}
</div>
